import * as angular from 'angular';
import * as _ from 'lodash';

import { GroupChangeBase } from '../groupChangeBase';
import { guidEmpty } from '../../../common';
import { ValueTypes } from '../../../common/ValueTypes';
import { ISeriesSelectorService, IGroupService } from '../../../services';
import { SeriesSelectorViewModel, FlatGroup, ComponentDefinition } from '../../../models';
import { SeriesConfiguration } from '../../../widgets';

class GroupChangesTrend extends GroupChangeBase implements angular.IComponentController {
    isLoading = false;
    display: any[];

    private _allSeries: SeriesSelectorViewModel[];
    private _missing: string;
    private _allValueTypes = ValueTypes.allValueTypes;

    static $inject = [
        '$q',
        '$translate',
        'groupService',
        'seriesSelectorService'
    ];

    constructor(
        private $q: angular.IQService,
        private $translate: angular.translate.ITranslateService,
        private groupService: IGroupService,
        private seriesSelectorService: ISeriesSelectorService
    ) {
        super();
    }

    $onInit() {
        this._missing = this.$translate.instant('Unknown');
        this.refresh();

        if (this.master) {
            const self = this;
            this.share.diff.applyAllFromTemplate = () => this.applyAllFromTemplate(self);
            this.share.diff.applyAllFromGroup = () => this.applyAllFromGroup(self);
            this.share.diff.ignoreAll = () => this.ignoreAll(self);
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['groups'] || changesObj['templates'] || changesObj['changes']) {
            this.refresh();
        }
    }

    private refresh() {
        this.display = [];
        if (this.groups && this.templates && this.changes) {
            this.isLoading = true;
            this.groups.forEach(group => {
                const template = _.find(this.templates, t => group.templateGuid === t.guid);
                if (template) {
                    this.display.push(this.buildViewGroup(group, template));
                }
            });
            this.createAlignButtons();
            this.isLoading = false;
        }
    }

    private createAlignButtons() {
        const self = this;
        this.share.central = [];

        this.display.forEach(g => {

            const toAdd = (g.isDifferent)
                ? {
                    leftAction: () => self.share.diff.applyFromGroup(g.change),
                    leftSelected: () => self.share.selectedDiff.fromGroup[g.change],
                    ignoreAction: () => self.share.diff.ignore(g.change),
                    ignoreSelected: () => self.share.selectedDiff.ignores[g.change],
                    rightAction: () => self.share.diff.applyFromTemplate(g.change),
                    rightSelected: () => self.share.selectedDiff.fromTemplate[g.change]
                }
                : {};

            this.share.central.push(toAdd);

            for (let i = 0; i < g.numberOfSerie; i++) {
                this.share.central.push({});
            }
        });
    }

    private buildViewGroup(group: FlatGroup, template: FlatGroup): any {
        const view = {
            guid: group.guid,
            groupName: group.name,
            templateName: template.name,
            identifiers: [],
            depth: (<any>group).depth,
            isDifferent: false,
            changeGuid: guidEmpty,
            change: undefined,
            groupSeries: [],
            templateSeries: [],
            numberOfSerie: 0
        };

        const found = _.find(this.changes, c => c.objectGuid === group.guid);
        if (found) {
            view.isDifferent = true;
            view.changeGuid = found.differenceCollection[0].guid;
            view.change = found.differenceCollection[0];

            this.$q.all([
                this.seriesSelectorService.getSeriesSelectorViewModels(false),
                this.groupService.getConfigurationForGroup(group.guid),
                this.groupService.getConfigurationForGroup(template.guid)
            ]).then(data => {
                const [allSeries, groupSeries, templateSeries] = data;
                this._allSeries = allSeries;

                view.groupSeries = groupSeries.seriesConfigurationCollection.map(s => {
                    const found = _.find(this._allSeries, serie => serie.guid === s.guid);
                    return this.getSerieLabel(s, found);
                });

                view.templateSeries = templateSeries.seriesConfigurationCollection.map(s => {
                    let found: any = _.find(this._allSeries, serie => serie.guid === s.guid);
                    if (!found) {
                        const allTemplateIdentifiers = _.flatten(this.templates.map(t => t.identifierCollection));
                        found = _.find(allTemplateIdentifiers, serie => serie.guid === s.guid);
                    }
                    return this.getSerieLabel(s, found);
                });

                view.numberOfSerie = Math.max(view.groupSeries.length, view.templateSeries.length);
            }).finally(() => {
                this.createAlignButtons();
            });
        }

        return view;
    }

    private getSerieLabel(serie: SeriesConfiguration, vm) {
        const label = _.find(this._allValueTypes, vt => vt.key === serie.value);
        return `${vm ? vm.name : this._missing} (${this.$translate.instant(label.value)})`;
    }

    private applyAllFromTemplate(self: this) {
        this.display.forEach(g => {
            if (g.isDifferent) {
                self.share.diff.applyFromTemplate(g.change);
            }
        });
    }

    private applyAllFromGroup(self: this) {
        this.display.forEach(g => {
            if (g.isDifferent) {
                self.share.diff.applyFromGroup(g.change);
            }
        });
    }
    private ignoreAll(self: this) {
        this.display.forEach(g => {
            if (g.isDifferent) {
                self.share.diff.ignore(g.change);
            }
        });
    }
}

export const wtGroupChangesTrendWidget: ComponentDefinition = {
    componentId: 'wtGroupChangesTrend',
    controller: GroupChangesTrend,
    controllerAs: 'vm',
    template: require('./groupChangesTrend.component.html'),
    bindings: {
        changes: '<',
        groups: '<',
        templates: '<',
        master: '=?',
        share: '='
    }
};